import { CloseOutlined } from '@ant-design/icons';
import { Select as AntSelect, Spin } from 'antd';
import classNames from 'classnames';

import { ArrowDown } from '@/assets';
import { handlePopupScroll } from '@/utils';

import styles from './styles.module.scss';

type Props = {
  classname?: string;
  fetchData?: () => Promise<void>;
  hasMore?: boolean;
  isEditor?: boolean;
  loading?: boolean;
  onChange?: (
    value: any,
    option?:
      | {
          label: string;
          value: string | number;
        }
      | {
          label: string;
          value: string | number;
        }[],
  ) => void;
  options: { label: string; value: string | number | boolean }[];
  value?: any;
};

export const Select: React.FC<Props> = ({
  classname,
  fetchData,
  hasMore,
  isEditor,
  loading,
  onChange,
  options,
  value,
}) => (
  <AntSelect
    size="large"
    popupClassName={styles.selectorOptions}
    dropdownStyle={{ backgroundColor: 'var(--color-grey-lvl1)' }}
    notFoundContent={loading ? <Spin size="small" /> : null}
    allowClear={!isEditor}
    onClear={() => onChange(null)}
    options={options}
    value={value}
    onChange={onChange}
    suffixIcon={<ArrowDown className={styles.icon} />}
    clearIcon={<CloseOutlined />}
    className={classNames(styles.selector, styles[classname])}
    onPopupScroll={(e) => handlePopupScroll(e, fetchData, hasMore)}
    placeholder="Выбрать"
  />
);
